export default "__VITE_ASSET__gffSMH9G__"